import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/web-toit.io/web-toit.io/src/components/MdxLayout.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageTitle = makeShortcode("PageTitle");
const Section = makeShortcode("Section");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageTitle title="Privacy policy" subTitle="Last updated: February 26, 2025." mdxType="PageTitle" />
    <Section mdxType="Section">
      <p>{`Florian Loitsch and Kasper Lund ("us", "we", or "our") operate `}<a parentName="p" {...{
          "href": "http://www.toit.io"
        }}>{`www.toit.io`}</a>{` (the "site"). This page informs you of our policies regarding the collection, use and disclosure of personal information we receive from users of the site. We use your personal information only for providing and improving the site. By using the site, you agree to the collection and use of information in accordance with this policy.`}</p>
      <h2>{`Information collection and use`}</h2>
      <p>{`While using our site, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you. Personally identifiable information may include, but is not limited to your name ("personal information"). Like many site operators, we collect information that your browser sends whenever you visit our site. This information may include information such as your computer's Internet Protocol ("IP") address, browser type, browser version, the pages of our site that you visit, the time and date of your visit, the time spent on those pages and other statistics. We use third party services such as Google Analytics to collect, monitor and analyze this data.`}</p>
      <h2>{`Communications`}</h2>
      <p>{`We may use your personal information to contact you with newsletters, marketing or promotional materials and other information if you have chosen to subcribe to our newsletter. We store your e-mail address, your first and last names, your company or organization, and your job title. Furthermore, we store your newsletter subscription preferences.`}</p>
      <h2>{`Cookies`}</h2>
      <p>{`See our `}<a parentName="p" {...{
          "href": "/cookies-policy"
        }}>{`cookies policy`}</a>{` for more information about how we use cookies.`}</p>
      <h2>{`Security`}</h2>
      <p>{`The security of your personal information is important to us, but remember that no method of transmission over the internet, or method of electronic storage, is 100% secure. While we strive to use commercially acceptable means to protect your personal information, we cannot guarantee its absolute security.`}</p>
      <h2>{`Changes to this privacy policy`}</h2>
      <p>{`This privacy policy is effective as of January 4, 2019 and will remain in effect except with respect to any changes in its provisions in the future, which will be in effect immediately after being posted on this page.`}</p>
      <p>{`We reserve the right to update or change our privacy policy at any time and you should check this privacy policy periodically. Your continued use of the site after we post any modifications to the privacy policy on this page will constitute your acknowledgment of the modifications and your consent to abide and be bound by the modified privacy policy.`}</p>
      <p>{`If we make any material changes to this privacy policy, we will notify you either through the e-mail address you have provided us if you have subscribed to our newsletters, or by placing a prominent notice on our website.`}</p>
      <h2>{`Contact us`}</h2>
      <p>{`If you have any questions about this privacy policy, please `}<a href="mailto:contact@toit.io">{`contact us`}</a>{`.`}</p>
    </Section>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      